import { Component, OnInit } from '@angular/core';
import { SysInfoService } from '../../services/systemInfo/system-info.service';
import { AuthService } from '../../services/auth/auth.service';
import { ConfigService } from '../../services/config/config.service';
import { LoggingService } from '../../services/shared/logging/logging.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  appVersion = environment.appVersion;
  apiVersion = '';
  apiBasePath = '';
  constructor(
    private sysInfoService: SysInfoService,
    private authService: AuthService,
    private configService: ConfigService,
    private loggingService: LoggingService
  ) {
    this.apiBasePath = this.configService.config?.apiBasePath || 'UNKNOWN';
  }
  ngOnInit() {
    if (!this.authService.isAuthenticated()) {
      return;
    }
    this.sysInfoService.getSystemInfo().subscribe(
      (systemInfo) => {
        if (systemInfo) {
          this.apiVersion = systemInfo.version || 'UNKNOWN';
        }
      },
      (error) => {
        this.loggingService.error('Error fetching system info:', error);
        this.apiVersion = 'UNKNOWN';
      }
    );
  }
}
